/*
    S_MENU.JS
*/


function refreshMenu() {
    /* IF MENU IS ABSOLUTE */
    if(window.currentPageType == window.PAGE_TYPE_INSTRUMENTS) {
        remainingScroll = $(window).height()-window.scrollTop;
        // buySectionHeight = $(window).height()/100*8;
        buySectionHeight = $('#buy-section').height();
        if(!buySectionStick && remainingScroll <= buySectionHeight) {
            $('#buy-section').addClass('stick');
            $('#buy-title').addClass('buy-title-visible');
            buySectionStick = true;
            if(document.getElementById('strike-price'))
                document.getElementById('strike-mob').style.opacity = '0';
        }
        else if(buySectionStick && remainingScroll > buySectionHeight) {
            buySectionStick = false;
            $('#buy-section').removeClass('stick');  
            $('#buy-title').removeClass('buy-title-visible');
            if(document.getElementById('strike-price'))
                document.getElementById('strike-mob').style.opacity = '1';
        } 
    }  
}